import type { FC } from 'react';
import React from 'react';
import { Box } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Text } from '@edreamsodigeo/prisma-design-system/deprecated';

const FlightSummaryMetaHeader: FC<{
  destinationName: string;
}> = ({ destinationName }) => {
  const { t } = useTranslation();

  return (
    <Box mt="big" px="base">
      <Text color="neutral.90" fontSize="heading.0" fontWeight="medium">
        {t('flightSummary.journey.title', {
          destinationName,
        })}
      </Text>
    </Box>
  );
};

export default FlightSummaryMetaHeader;
